import { environment } from '../../../environments/environment';
import {
  DEBOUNCE_TIME,
  EMPTY_DEBOUNCE_TIME,
} from '@shared/constants/common.constants';

export const getDebounceTime = () =>
  environment?.playwright ? EMPTY_DEBOUNCE_TIME : DEBOUNCE_TIME;
